export const MESSAGE_DIALOG_ADD_ERROR = 'MESSAGE_DIALOG_ADD_ERROR';
export const MESSAGE_DIALOG_ADD_INFO = 'MESSAGE_DIALOG_ADD_INFO';
export const MESSAGE_DIALOG_DISMISS_ALL = 'MESSAGE_DIALOG_DISMISS_ALL';
export const MESSAGE_DIALOG_ERROR_INTL = 'MESSAGE_DIALOG_ERROR_INTL';
export const MESSAGE_DIALOG_INFO_INTL = 'MESSAGE_DIALOG_INFO_INTL';
export const MESSAGE_DISCLAIMER = 'MESSAGE_DISCLAIMER';



// WEBPACK FOOTER //
// ./src/js/actions/messageDialogActionTypes.js